var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('FORM',{ref:"childForm",attrs:{"formData":_vm.formData},on:{"formclick":_vm.formclick}}),_vm._v(" "),_c('table-page',{ref:"childTable",attrs:{"pageData":_vm.pageData},on:{"checkbox":_vm.checkbox}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }